/* eslint-disable no-useless-concat */

/* eslint-disable no-param-reassign */

import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';

import Immutable from 'immutable';

import PropTypes from 'prop-types';

import { Col, Form, FormGroup, InputGroupText, Label, Row } from 'reactstrap';

import { connect } from 'react-redux';

import { change, Field, formValueSelector, reduxForm } from 'redux-form';

import FormItem from '../../../common/forms/FormItem';

import CustomerInputGroup from '../../../common/forms/CustomerInputGroup';

import {
  isRequired,
  validateEndDate,
  validateIntegerNumber,
} from '../../../../utils/validators';

import BusinessInputGroup from '../../../common/forms/BusinessInputGroup';

import Loader from '../../../common/Loader';

import TextInput from '../../../common/forms/input/TextInput';

import VoucherTypeSelect from '../../../common/forms/select/VoucherTypeSelect';

import DatePicker from '../../../common/forms/input/DatePicker';

import {
  MANUAL_VOUCHER_PAYMENT_TYPE,
  CURRENCY_CODE,
  CONTRACT_DOCUMENT_TYPE,
  SUNAT_CREDIT_NOTE_CODE,
  SUNAT_DEBIT_NOTE_CODE,
  SUNAT_TICKET_CODE,
  SUNAT_INVOICE_CODE,
  MANUAL_VOUCHER_SERVICE_TYPE,
} from '../../../../config/constants';

import { enumToSelectOptions } from '../../../../utils/enum';

import Select from '../../../common/forms/select/Select';

import DynamicForm from '../../../common/forms/DynamicForm';

import { generateManualVoucherFormColumns } from '../../../../config/dynamicFormFields';

import { currencyToNumber, numberFormatter } from '../../../../utils/number';

import {
  optionPropTypes,
  optionsPropTypes,
} from '../../../common/forms/select/SelectPropTypes';

import PrivateServiceSearchButton from '../../../common/button/PrivateServiceSearchButton';

import ManualVoucherSearchInput from '../../../common/forms/input/ManualVoucherSearchInput';

import FormFooter from '../../../common/forms/FormFooter';

import { tzNormalizeDate } from '../../../../utils/date';

import { clearCargoCorporateCreditManualVoucherValues } from '../../../../actions/cargo/CargoCorporateCredit';

import { clearTicketCorporateCreditManualVoucherValues } from '../../../../actions/corporate/TicketCorporateCredit';

import ManualVoucherServiceTypeSelect from '../../../common/forms/select/ManualVoucherServiceTypeSelect';

import { INT_DATE_FORMAT } from '../../../../config/locale';

import {
  clearCurrencyRate,
  getCurrencyRate,
} from '../../../../actions/sap-service-layer';

import CostCenterSelect from '../../../common/forms/select/CostCenterSelect';

const selector = formValueSelector('ManualVoucherForm');

const REQUIRED_VALIDATION = [isRequired];

const INTEGER_VALIDATION = [validateIntegerNumber];

const validateDate = (value, allValues) =>
  validateEndDate(value, allValues.issueDate);

const REQUIRED_DATE_VALIDATION = [isRequired, validateDate];

const validateFields = (values) => {
  const errors = {};

  if (!values.items || !values.items.length) {
    errors.itemsError = 'Debe ingresar un item';
  }

  return errors;
};

const ManualVoucherForm = ({
  loading,

  handleSubmit,

  dispatchChange,

  items,

  totalAmount,

  initialValues,

  voucherTypeOptions,

  cargoCorporateCreditValues,

  ticketCorporateCreditValues,

  dispatchClearCargoCorporateCreditManualVoucherValues,

  dispatchClearTicketCorporateCreditManualVoucherValues,

  detraction,

  manualVoucherServiceTypes,

  dispatchGetCurrencyRate,

  dispatchClearCurrencyRate,

  currencyRate,

  showPrivateServiceSearch,
}) => {
  const [isPerson, setIsPerson] = useState(
    initialValues ? initialValues.isPerson : false,
  );

  const [hasCreditPayment, setHasCreditPayment] = useState(
    initialValues.paymentType.value ===
      MANUAL_VOUCHER_PAYMENT_TYPE.CREDIT.value,
  );

  const [recalculationRevision, setRecalculationRevision] = useState(0);

  const [affectedByTaxes, setAffectedByTaxes] = useState(
    initialValues ? !!initialValues.affectedByTaxes : false,
  );

  const [dueDateValue, setDueDateValue] = useState(initialValues.dueDate);

  const [currencyCodeValue, setCurrencyCodeValue] = useState(
    initialValues.currencyCode.value,
  );

  const [voucherCodeValue, setVoucherCodeValue] = useState(
    initialValues.voucherTypeId && initialValues.voucherTypeId.voucherCode,
  );

  const [minimumDetractionAmount, setMinimumDetractionAmount] = useState(null);

  const [typeServiceValue, setTypeServiceValue] = useState(null);

  const initialRender = useRef(true);

  const manualDetractionOverride = useRef(null);

  useLayoutEffect(() => {
    dispatchGetCurrencyRate({
      date: tzNormalizeDate({
        format: INT_DATE_FORMAT,
      }),

      currency: CURRENCY_CODE.USD.value,
    });

    return () => {
      dispatchClearCurrencyRate();
    };
  }, []);

  useLayoutEffect(() => {
    if (currencyRate && currencyRate.value) {
      const { value: currencyValue } = currencyRate;

      const currencyNumber = numberFormatter({
        style: 'currency',

        value: currencyValue,
      });

      dispatchChange('ManualVoucherForm', 'currencyRate', currencyNumber);
    } else {
      dispatchChange('ManualVoucherForm', 'currencyRate', '-');
    }
  }, [currencyRate && currencyRate.value]);

  const findServiceType = (serviceType) => {
    if (manualVoucherServiceTypes.length === 0) {
      return null;
    }

    return manualVoucherServiceTypes.find(({ type }) => type === serviceType);
  };

  useLayoutEffect(() => {
    if (
      cargoCorporateCreditValues.isEmpty() &&
      ticketCorporateCreditValues.isEmpty() &&
      initialValues &&
      initialValues.serviceType &&
      manualVoucherServiceTypes.length > 0 &&
      initialRender.current &&
      typeServiceValue === null
    ) {
      setTypeServiceValue(initialValues.serviceType.value);

      initialRender.current = false;
    }
  }, [
    initialValues,

    cargoCorporateCreditValues,

    ticketCorporateCreditValues,

    manualVoucherServiceTypes.length,
  ]);

  const round2 = (value) => Math.round((value + Number.EPSILON) * 100) / 100;

  const calculateTotalAmount = () => {
    const format = (value) =>
      numberFormatter({
        style: 'currency',
        value,
        currency: currencyCodeValue,
      });

    const newItems = (items || []).map((item) => {
      const quantity = currencyToNumber(item.quantity) || 0;
      const unitPrice = currencyToNumber(item.unitaryPrice) || 0;
      return {
        ...item,
        totalPrice: format(round2(quantity * unitPrice)),
      };
    });

    // Actualizar los ítems solo si su total realmente cambió.
    const itemsChanged = newItems.some(
      (item, index) => item.totalPrice !== items[index].totalPrice,
    );
    if (itemsChanged) {
      dispatchChange('ManualVoucherForm', 'items', newItems);
    }

    const rawSubtotal = (items || []).reduce((sum, item) => {
      const quantity = currencyToNumber(item.quantity) || 0;
      const unitPrice = currencyToNumber(item.unitaryPrice) || 0;
      return sum + quantity * unitPrice;
    }, 0);

    const subtotal = round2(rawSubtotal);
    const total = affectedByTaxes ? round2(rawSubtotal * 1.18) : subtotal;
    const taxes = round2(total - subtotal); // el IGV absorbe el céntimo de diferencia

    const serviceConfig = findServiceType(typeServiceValue);
    const detractionConfig =
      serviceConfig && serviceConfig.manualVoucherDetraction
        ? serviceConfig.manualVoucherDetraction
        : null;
    const minimumAmount =
      detractionConfig && detractionConfig.minimumAmount != null
        ? detractionConfig.minimumAmount
        : null;
    const isEligible =
      voucherCodeValue === SUNAT_INVOICE_CODE &&
      minimumAmount !== null &&
      total >= Number(minimumAmount);
    const isOther =
      typeServiceValue === MANUAL_VOUCHER_SERVICE_TYPE.OTHER.value;

    const configuredPercent = detractionConfig
      ? Number(detractionConfig.percentage) || 0
      : 0;
    const override = isOther ? manualDetractionOverride.current : null;
    // eslint-disable-next-line no-nested-ternary
    const percentage = isEligible
      ? override !== null
        ? override
        : configuredPercent
      : null;
    const detractionAmount =
      percentage === null ? 0 : round2((total * percentage) / 100);
    const payable = round2(total - detractionAmount);

    // Actualizaciones de los valores derivados. Evita escribir detraction
    // si no cambia, para prevenir bucles de efectos en redux-form.
    dispatchChange(
      'ManualVoucherForm',
      'totalAmountWithoutTaxes',
      format(subtotal),
    );
    dispatchChange('ManualVoucherForm', 'taxes', format(taxes));
    dispatchChange('ManualVoucherForm', 'totalAmount', format(total));
    dispatchChange(
      'ManualVoucherForm',
      'detractionAmount',
      isEligible ? format(detractionAmount) : null,
    );
    dispatchChange('ManualVoucherForm', 'totalAmountPayable', format(payable));

    if ((detraction == null ? null : detraction) !== percentage) {
      dispatchChange('ManualVoucherForm', 'detraction', percentage);
    }
    setMinimumDetractionAmount((previous) =>
      previous === minimumAmount ? previous : minimumAmount,
    );
  };

  useLayoutEffect(
    () => () => {
      dispatchClearCargoCorporateCreditManualVoucherValues();

      dispatchClearTicketCorporateCreditManualVoucherValues();
    },

    [],
  );

  const activateCalculateTotal = () =>
    setRecalculationRevision((value) => value + 1);

  useEffect(() => {
    calculateTotalAmount();
  }, [
    items,
    affectedByTaxes,
    currencyCodeValue,
    typeServiceValue,
    voucherCodeValue,
    manualVoucherServiceTypes,
    detraction,
    recalculationRevision,
  ]);

  useEffect(() => {
    if (!showPrivateServiceSearch && ticketCorporateCreditValues.isEmpty()) {
      setAffectedByTaxes(true);

      dispatchChange('ManualVoucherForm', 'affectedByTaxes', true);

      activateCalculateTotal();
    }
  }, [showPrivateServiceSearch, dispatchChange, ticketCorporateCreditValues]);

  useEffect(() => {
    activateCalculateTotal();
  }, [affectedByTaxes]);

  useEffect(() => {
    if (!cargoCorporateCreditValues.isEmpty()) {
      const {
        business,

        customer,

        voucherType,

        items: cargoItems,
      } = cargoCorporateCreditValues.toJS();

      let businessId = null;

      let customerId = null;

      if (customer) {
        customerId = {
          value: customer.id,

          label: customer.fullName,

          id: customer.id,

          firstName: customer.firstName,

          lastName: customer.lastName,

          fullName: customer.fullName,

          idDocumentNumber: customer.idDocument,
        };

        setIsPerson(true);
      }

      if (business) {
        businessId = {
          value: business.id,

          label: `${business.businessTaxId} - ` + `${business.name}`,

          businessTaxId: business.businessTaxId,

          name: business.name,

          email: business.email,

          primaryContact: business.primaryContact,

          phone: business.phone,

          fax: business.fax,

          addressSummary: business.addressSummary,

          addressId: business.addressId,

          address: business.address,
        };
      }

      const voucherTypeId = {
        value: voucherType.id,

        label: voucherType.name,

        voucherCode: voucherType.voucherCode,
      };

      initialValues.businessId = businessId;

      initialValues.customerId = customerId;

      initialValues.voucherTypeId = voucherTypeId;

      setTypeServiceValue(MANUAL_VOUCHER_SERVICE_TYPE.PARCEL.value);

      initialValues.affectedByTaxes = true;

      setAffectedByTaxes(true);

      setVoucherCodeValue(voucherType.voucherCode);

      dispatchChange('ManualVoucherForm', 'items', cargoItems);

      activateCalculateTotal();
    }
  }, [cargoCorporateCreditValues]);

  useEffect(() => {
    if (!ticketCorporateCreditValues.isEmpty()) {
      const {
        business,

        voucherType,

        items: ticketItems,
      } = ticketCorporateCreditValues.toJS();

      let businessId = null;

      if (business) {
        businessId = {
          value: business.id,

          label: `${business.businessTaxId} - ` + `${business.name}`,

          businessTaxId: business.businessTaxId,

          name: business.name,

          email: business.email,

          primaryContact: business.primaryContact,

          phone: business.phone,

          fax: business.fax,

          addressSummary: business.addressSummary,

          addressId: business.addressId,

          address: business.address,
        };
      }

      let voucherTypeId = null;

      if (voucherType) {
        voucherTypeId = {
          value: voucherType.id,

          label: voucherType.name,

          voucherCode: voucherType.voucherCode,
        };
      }

      setIsPerson(false);

      dispatchChange('ManualVoucherForm', 'isPerson', false);

      dispatchChange('ManualVoucherForm', 'customerId', null);

      dispatchChange('ManualVoucherForm', 'businessId', businessId);

      dispatchChange('ManualVoucherForm', 'voucherTypeId', voucherTypeId);

      if (voucherType) {
        setVoucherCodeValue(voucherType.voucherCode);
      }

      setAffectedByTaxes(false);

      dispatchChange('ManualVoucherForm', 'affectedByTaxes', false);

      dispatchChange('ManualVoucherForm', 'items', ticketItems || []);

      activateCalculateTotal();
    }
  }, [ticketCorporateCreditValues]);

  const onChangeDetraction = ({ target: { value } }) => {
    const percent = Number(value);
    if (
      typeServiceValue !== MANUAL_VOUCHER_SERVICE_TYPE.OTHER.value ||
      !Number.isFinite(percent) ||
      percent < 0 ||
      percent > 100
    ) {
      return;
    }
    manualDetractionOverride.current = percent;
    dispatchChange('ManualVoucherForm', 'detraction', percent);
    activateCalculateTotal();
  };

  const onChangeIsPerson = ({ target: { checked } }) => {
    dispatchChange('ManualVoucherForm', 'businessId', null);

    dispatchChange('ManualVoucherForm', 'customerId', null);

    setIsPerson(checked);
  };

  const onChangeIssueDate = (e, value) => {
    setDueDateValue(value);

    if (!hasCreditPayment) {
      dispatchChange('ManualVoucherForm', 'dueDate', value);
    }
  };

  const onChangeAffectedByTaxes = ({ target: { checked } }) => {
    setAffectedByTaxes(checked);

    activateCalculateTotal();
  };

  const onChangeCurrencyCode = (option) => {
    setCurrencyCodeValue(option.value);

    activateCalculateTotal();
  };

  const onChangePaymentType = (option) => {
    if (option.value === MANUAL_VOUCHER_PAYMENT_TYPE.CASH.value) {
      dispatchChange('ManualVoucherForm', 'dueDate', dueDateValue);
    }

    dispatchChange('ManualVoucherForm', 'installments', null);

    setHasCreditPayment(
      option.value === MANUAL_VOUCHER_PAYMENT_TYPE.CREDIT.value,
    );
  };

  const onChangeVoucherType = (option) =>
    setVoucherCodeValue(option.voucherCode);

  const onClickRemoveItem = (index, fields) => {
    fields.remove(index);

    activateCalculateTotal();
  };

  const resetForm = (data = null) => {
    const today = tzNormalizeDate();

    dispatchChange('ManualVoucherForm', 'isPerson', false);

    onChangeIsPerson({
      target: {
        checked: false,
      },
    });

    dispatchChange('ManualVoucherForm', 'voucherTypeId', null);

    dispatchChange('ManualVoucherForm', 'documentSeries', null);

    dispatchChange('ManualVoucherForm', 'documentCode', null);

    dispatchChange('ManualVoucherForm', 'issueDate', today);

    dispatchChange('ManualVoucherForm', 'affectedByTaxes', null);

    dispatchChange('ManualVoucherForm', 'currencyCode', CURRENCY_CODE.PEN);

    onChangeCurrencyCode(CURRENCY_CODE.PEN);

    dispatchChange('ManualVoucherForm', 'description', null);

    dispatchChange(
      'ManualVoucherForm',

      'paymentType',

      MANUAL_VOUCHER_PAYMENT_TYPE.CASH,
    );

    onChangePaymentType(MANUAL_VOUCHER_PAYMENT_TYPE.CASH);

    dispatchChange('ManualVoucherForm', 'dueDate', today);

    dispatchChange('ManualVoucherForm', 'itemsError', null);

    dispatchChange('ManualVoucherForm', 'items', []);

    dispatchChange('ManualVoucherForm', 'detraction', null);
    dispatchChange('ManualVoucherForm', 'detractionAmount', null);
    manualDetractionOverride.current = null;

    if (data) {
      const {
        business,

        customer,

        voucherTypeId,

        affectedByTaxes: currentAffectedByTaxes,

        currencyCode,

        paymentType,

        installments,

        items: currentItems,

        detraction: currentDetraction,
      } = data;

      const businessId = business && {
        value: business.id,

        // eslint-disable-next-line no-useless-concat

        label: `${business.businessTaxId} - ` + `${business.name}`,

        businessTaxId: business.businessTaxId,

        name: business.name,

        email: business.email,

        primaryContact: business.primaryContact,

        phone: business.phone,

        fax: business.fax,

        addressSummary: business.addressSummary,

        addressId: business.addressId,

        address: business.address,
      };

      const customerId = customer && {
        value: customer.id,

        label: customer.fullName,

        id: customer.id,

        firstName: customer.firstName,

        lastName: customer.lastName,

        fullName: customer.fullName,

        idDocumentNumber: customer.idDocumentNumber,

        gender: customer.gender,

        idCountryOfOrigin: customer.idCountryOfOrigin,

        identificationType: customer.identificationType,

        email: customer.email,

        mobilePhone: customer.mobilePhone,

        dob: customer.dob,

        discountCode: customer.discountCode,
      };

      const newIsPerson = !!customer;

      dispatchChange('ManualVoucherForm', 'isPerson', newIsPerson);

      onChangeIsPerson({
        target: {
          checked: newIsPerson,
        },
      });

      if (customerId) {
        dispatchChange('ManualVoucherForm', 'customerId', customerId);
      }

      if (businessId) {
        dispatchChange('ManualVoucherForm', 'businessId', businessId);
      }

      dispatchChange('ManualVoucherForm', 'voucherTypeId', voucherTypeId);

      onChangeVoucherType(voucherTypeId);

      setTypeServiceValue(MANUAL_VOUCHER_SERVICE_TYPE.CONTRACT.value);

      dispatchChange(
        'ManualVoucherForm',

        'affectedByTaxes',

        currentAffectedByTaxes,
      );

      onChangeAffectedByTaxes({
        target: {
          checked: currentAffectedByTaxes,
        },
      });

      const currencyCodeSelected = CURRENCY_CODE[currencyCode];

      dispatchChange('ManualVoucherForm', 'currencyCode', currencyCodeSelected);

      onChangeCurrencyCode(currencyCodeSelected);

      const paymentTypeSelected = MANUAL_VOUCHER_PAYMENT_TYPE[paymentType];

      dispatchChange('ManualVoucherForm', 'paymentType', paymentTypeSelected);

      onChangePaymentType(paymentTypeSelected);

      dispatchChange('ManualVoucherForm', 'installments', installments);

      dispatchChange('ManualVoucherForm', 'items', currentItems);

      dispatchChange('ManualVoucherForm', 'detraction', currentDetraction);
      manualDetractionOverride.current = null;
    }
  };

  const onSelectManualVoucher = ({
    business,

    customer,

    serviceType,

    paymentType,

    installments,

    currencyCode,

    affectedByTaxes: currentAffectedByTaxes,

    items: currentItems,

    detraction: currentDetraction,
  }) => {
    const voucherTypeId = voucherTypeOptions.find(
      ({ voucherCode }) => voucherCode === SUNAT_CREDIT_NOTE_CODE,
    );

    const currencyCodeSelected = CURRENCY_CODE[currencyCode];

    const newItems = currentItems.map(
      ({
        quantity,

        description: itemDescription,

        unitaryPrice,

        totalPrice,
      }) => ({
        quantity,

        description: itemDescription,

        unitaryPrice,

        totalPrice: numberFormatter({
          style: 'currency',

          value: totalPrice,

          currency: currencyCodeSelected.value,
        }),
      }),
    );

    resetForm({
      business,

      customer,

      voucherTypeId,

      serviceType,

      affectedByTaxes: currentAffectedByTaxes,

      currencyCode,

      paymentType,

      installments,

      items: newItems,

      detraction: currentDetraction,
    });
  };

  const onSelectPrivateService = ({
    contractPaymentType,

    amountBeforeDiscount,

    source,

    destination,

    creditPayment,

    business,

    customer,
  }) => {
    dispatchChange('ManualVoucherForm', 'previousManualVoucherId', null);

    let voucherTypeId = voucherTypeOptions.find(
      ({ voucherCode }) => voucherCode === SUNAT_TICKET_CODE,
    );

    if (
      contractPaymentType === CONTRACT_DOCUMENT_TYPE.FACTURA.value ||
      contractPaymentType === CONTRACT_DOCUMENT_TYPE.BOLETA_INTERNA.value
    ) {
      voucherTypeId = voucherTypeOptions.find(
        ({ voucherCode }) => voucherCode === SUNAT_INVOICE_CODE,
      );
    }

    const currencyCodeSelected = CURRENCY_CODE.PEN;

    const newItems = [
      {
        quantity: 1,

        description:
          `Servicio de transporte de personal de ` +
          `${source} a ${destination}`,

        unitaryPrice: amountBeforeDiscount,
      },
    ];

    resetForm({
      business,

      customer,

      voucherTypeId,

      serviceType: MANUAL_VOUCHER_SERVICE_TYPE.CONTRACT.value,

      affectedByTaxes: false,

      currencyCode: currencyCodeSelected.value,

      paymentType: creditPayment
        ? MANUAL_VOUCHER_PAYMENT_TYPE.CREDIT.value
        : MANUAL_VOUCHER_PAYMENT_TYPE.CASH.value,

      installments: null,

      items: newItems,

      detraction: null,
    });
  };

  const onChangeServiceTypeSelect = ({ value }) => {
    manualDetractionOverride.current = null;
    setTypeServiceValue(value);
    dispatchChange('ManualVoucherForm', 'detraction', null);
    if (value !== MANUAL_VOUCHER_SERVICE_TYPE.OTHER.value) {
      dispatchChange('ManualVoucherForm', 'costCenterId', null);
    }
    activateCalculateTotal();
  };

  const currencyCodeField = currencyCodeValue === CURRENCY_CODE.USD.value && (
    <FormGroup row>
      <FormItem label="Tipo de Cambio">
        <Row>
          <Col lg={3} sm={12}>
            <Field
              name="currencyRate"
              component={TextInput}
              placeholder="Tipo de Cambio"
              disabled
            />
          </Col>
        </Row>
      </FormItem>
    </FormGroup>
  );

  if (loading) {
    return <Loader />;
  }

  let customerField = (
    <BusinessInputGroup
      label="Empresa"
      labelRequired
      name="businessId"
      form="ManualVoucherForm"
      validate={REQUIRED_VALIDATION}
      showDetails
    />
  );

  if (isPerson) {
    customerField = (
      <>
        <CustomerInputGroup
          label="Cliente"
          labelRequired
          name="customerId"
          form="ManualVoucherForm"
          validate={REQUIRED_VALIDATION}
          showDetails
        />
      </>
    );
  }

  const contractorDataFields = (
    <>
      <h3>Datos del Contratante</h3>

      <FormGroup row>
        <FormItem label="">
          <Label>
            <Field
              name="isPerson"
              component="input"
              type="checkbox"
              onChange={onChangeIsPerson}
            />{' '}
            Es persona Natural
          </Label>
        </FormItem>
      </FormGroup>

      {customerField}
    </>
  );

  const baseDocumentRequired = [
    SUNAT_CREDIT_NOTE_CODE,

    SUNAT_DEBIT_NOTE_CODE,
  ].includes(voucherCodeValue);

  const baseDocumentValidation = [
    SUNAT_CREDIT_NOTE_CODE,

    SUNAT_DEBIT_NOTE_CODE,
  ].includes(voucherCodeValue)
    ? REQUIRED_VALIDATION
    : null;

  const baseDocumentField = (
    <FormGroup row>
      <FormItem
        label="Comprobante Manual Previo"
        required={baseDocumentRequired}
      >
        <Field
          name="previousManualVoucherId"
          component={ManualVoucherSearchInput}
          placeholder="Comprobante Manual Previo"
          onSelectRow={onSelectManualVoucher}
          onClear={resetForm}
          props={{
            form: 'ManualVoucherForm',
          }}
          validate={baseDocumentValidation}
        />
      </FormItem>
    </FormGroup>
  );

  const descriptionField = [
    SUNAT_CREDIT_NOTE_CODE,

    SUNAT_DEBIT_NOTE_CODE,
  ].includes(voucherCodeValue) && (
    <FormGroup row>
      <FormItem label="Motivo o Sustento" required>
        <Field
          name="description"
          component={TextInput}
          type="textarea"
          placeholder="Motivo o Sustento"
          validate={REQUIRED_VALIDATION}
        />
      </FormItem>
    </FormGroup>
  );

  const costCenterField = typeServiceValue ===
    MANUAL_VOUCHER_SERVICE_TYPE.OTHER.value && (
    <FormGroup row>
      <FormItem label="Centro de Costo" required>
        <Row>
          <Col lg={6} md={8} sm={12}>
            <Field
              name="costCenterId"
              component={CostCenterSelect}
              validate={[isRequired]}
              isClearable={false}
              showCostCenterCode
            />
          </Col>
        </Row>
      </FormItem>
    </FormGroup>
  );

  const voucherDataFields = (
    <>
      <h3>Datos del Comprobante</h3>

      <FormGroup row>
        <FormItem label="Tipo de Comprobante" required>
          <Field
            name="voucherTypeId"
            component={VoucherTypeSelect}
            onChange={onChangeVoucherType}
            isClearable={false}
            validate={REQUIRED_VALIDATION}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="N° Comprobante">
          <Row>
            <Col lg={3} md={4} sm={5}>
              <Field
                name="documentSeries"
                id="documentSeries"
                component={TextInput}
                showToolTip
                type="text"
                placeholder="Serie"
                disabled
              />
            </Col>

            <Col lg={5} md={7} sm={6}>
              <Field
                name="documentCode"
                id="documentCode"
                component={TextInput}
                showToolTip
                type="text"
                placeholder="Correlativo"
                disabled
                validate={INTEGER_VALIDATION}
              />
            </Col>
          </Row>
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Tipo de Servicio" required>
          <Field
            name="serviceType"
            component={ManualVoucherServiceTypeSelect}
            validate={REQUIRED_VALIDATION}
            onChange={onChangeServiceTypeSelect}
          />
        </FormItem>
      </FormGroup>

      {costCenterField}

      <FormGroup row>
        <FormItem label="Fecha de Expedición" required>
          <Field
            name="issueDate"
            component={DatePicker}
            onChange={onChangeIssueDate}
            validate={REQUIRED_VALIDATION}
          />
        </FormItem>
      </FormGroup>

      {descriptionField}
    </>
  );

  const paymentDataFields = (
    <>
      <h3>Datos del Pago</h3>

      <FormGroup row>
        <FormItem label="">
          <Label>
            <Field
              name="affectedByTaxes"
              component="input"
              type="checkbox"
              onChange={onChangeAffectedByTaxes}
            />{' '}
            Afecta a Impuestos
          </Label>
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Moneda" required>
          <Field
            name="currencyCode"
            component={Select}
            options={enumToSelectOptions(CURRENCY_CODE)}
            onChange={onChangeCurrencyCode}
            isClearable={false}
            validate={REQUIRED_VALIDATION}
          />
        </FormItem>
      </FormGroup>

      {currencyCodeField}

      <FormGroup row>
        <FormItem label="Método de Pago" required>
          <Row>
            <Col lg={3} md={4} sm={12}>
              <Field
                name="paymentType"
                component={Select}
                options={enumToSelectOptions(MANUAL_VOUCHER_PAYMENT_TYPE)}
                onChange={onChangePaymentType}
                isClearable={false}
                validate={REQUIRED_VALIDATION}
              />
            </Col>

            <Col lg={2} md={3} sm={6}>
              <Field
                name="installments"
                id="installments"
                component={TextInput}
                showToolTip
                disabled={!hasCreditPayment}
                type="text"
                placeholder="Cuotas"
                validate={INTEGER_VALIDATION}
              />
            </Col>

            <Col lg={4} md={5} sm={6}>
              <Field
                name="dueDate"
                id="dueDate"
                component={DatePicker}
                disabled={!hasCreditPayment}
                placeholder="Fecha de Expiración"
                showToolTip
                validate={REQUIRED_DATE_VALIDATION}
              />
            </Col>
          </Row>
        </FormItem>
      </FormGroup>
    </>
  );

  const detractionFields = voucherCodeValue === SUNAT_INVOICE_CODE &&
    minimumDetractionAmount !== null &&
    currencyToNumber(totalAmount) >= minimumDetractionAmount && (
      <>
        <FormGroup row>
          <FormItem label="Porcentaje Detracción">
            <Field
              name="detraction"
              component={TextInput}
              type="text"
              placeholder="Porcentaje Detracción"
              append={<InputGroupText>%</InputGroupText>}
              onChange={onChangeDetraction}
              disabled={
                typeServiceValue !== MANUAL_VOUCHER_SERVICE_TYPE.OTHER.value
              }
            />
          </FormItem>
        </FormGroup>

        <FormGroup row className="align-items-center">
          <FormItem label="Monto Detracción">
            <Field
              name="detractionAmount"
              component={TextInput}
              type="text"
              placeholder="Monto Detracción"
              disabled
            />
          </FormItem>
        </FormGroup>

        <FormGroup row className="align-items-center">
          <FormItem label="Total a Pagar" required>
            <Field
              name="totalAmountPayable"
              component={TextInput}
              placeholder="Total a Pagar"
              type="text"
              size="lg"
              disabled
              validate={REQUIRED_VALIDATION}
            />
          </FormItem>
        </FormGroup>
      </>
    );

  const itemsDataFields = (
    <>
      <h4>Items a Facturar</h4>

      <Field name="itemsError" component={TextInput} type="hidden" />

      <DynamicForm
        name="items"
        title="Item"
        columns={generateManualVoucherFormColumns(
          activateCalculateTotal,

          activateCalculateTotal,
        )}
        onClickRemove={onClickRemoveItem}
      />

      <FormGroup row className="align-items-center">
        <FormItem label="Total Gravada" required>
          <Field
            name="totalAmountWithoutTaxes"
            component={TextInput}
            placeholder="Total Gravada"
            type="text"
            disabled
            validate={REQUIRED_VALIDATION}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row className="align-items-center">
        <FormItem label="Total IGV 18%">
          <Field
            name="taxes"
            component={TextInput}
            placeholder="Total IGV 18%"
            type="text"
            disabled
          />
        </FormItem>
      </FormGroup>

      <FormGroup row className="align-items-center">
        <FormItem label="Importe Total" required>
          <Field
            name="totalAmount"
            component={TextInput}
            placeholder="Importe Total"
            type="text"
            size="lg"
            disabled
            validate={REQUIRED_VALIDATION}
          />
        </FormItem>
      </FormGroup>

      {detractionFields}
    </>
  );

  return (
    <>
      {showPrivateServiceSearch && (
        <div className="text-center border-bottom pb-2 mb-3">
          <PrivateServiceSearchButton
            title="Completar con datos de Contrato"
            getRowData={onSelectPrivateService}
            size="sm"
          />
        </div>
      )}

      <Form onSubmit={handleSubmit}>
        {baseDocumentField}

        {contractorDataFields}

        <hr />

        {voucherDataFields}

        <hr />

        {paymentDataFields}

        {itemsDataFields}

        <FormFooter
          saveButtonDisabled={loading}
          saveButtonIcon={loading ? 'fa fa-spinner fa-spin' : 'fa fa-save'}
        />
      </Form>
    </>
  );
};

ManualVoucherForm.propTypes = {
  loading: PropTypes.bool.isRequired,

  handleSubmit: PropTypes.func.isRequired,

  dispatchChange: PropTypes.func.isRequired,

  items: PropTypes.arrayOf(
    PropTypes.shape({
      quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

      description: PropTypes.string,

      unitaryPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

      totalPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
  ),

  totalAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  detraction: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  initialValues: PropTypes.shape({
    dueDate: PropTypes.string,

    currencyCode: optionPropTypes,

    paymentType: optionPropTypes,

    isPerson: PropTypes.bool,

    voucherTypeId: optionPropTypes,

    businessId: PropTypes.instanceOf(Object),

    customerId: PropTypes.instanceOf(Object),

    serviceType: PropTypes.instanceOf(Object),

    items: PropTypes.instanceOf(Array),

    affectedByTaxes: PropTypes.bool,
  }),

  voucherTypeOptions: optionsPropTypes,

  cargoCorporateCreditValues: PropTypes.instanceOf(Immutable.Map),

  ticketCorporateCreditValues: PropTypes.instanceOf(Immutable.Map),

  dispatchClearCargoCorporateCreditManualVoucherValues:
    PropTypes.func.isRequired,

  dispatchClearTicketCorporateCreditManualVoucherValues:
    PropTypes.func.isRequired,

  manualVoucherServiceTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,

      name: PropTypes.string.isRequired,

      type: PropTypes.string.isRequired,

      manualVoucherDetraction: PropTypes.shape({
        id: PropTypes.string.isRequired,

        minimumAmount: PropTypes.number.isRequired,

        percentage: PropTypes.number.isRequired,
      }),
    }),
  ).isRequired,

  dispatchGetCurrencyRate: PropTypes.func.isRequired,

  dispatchClearCurrencyRate: PropTypes.func.isRequired,

  currencyRate: PropTypes.shape({
    value: PropTypes.number,
  }),

  showPrivateServiceSearch: PropTypes.bool,
};

ManualVoucherForm.defaultProps = {
  initialValues: null,

  items: [],

  totalAmount: 0,

  detraction: null,

  voucherTypeOptions: [],

  cargoCorporateCreditValues: Immutable.Map(),

  ticketCorporateCreditValues: Immutable.Map(),

  currencyRate: {},

  showPrivateServiceSearch: true,
};

let voucherTypesSource = null;

let voucherTypeOptionsCache = [];

let serviceTypesSource = null;

let manualVoucherServiceTypesCache = [];

let currencyRateSource = null;

let currencyRateCache = {};

const getVoucherTypeOptions = (state) => {
  const source = state.AccountingUnit.VoucherType.getIn([
    'all',

    'content',

    'content',
  ]);

  if (source !== voucherTypesSource) {
    voucherTypesSource = source;

    voucherTypeOptionsCache = source
      ? source.map((voucherType) => ({
          value: voucherType.id,

          label: voucherType.name,

          voucherCode: voucherType.voucherCode,
        }))
      : [];
  }

  return voucherTypeOptionsCache;
};

const getManualVoucherServiceTypes = (state) => {
  const source = state.AccountingUnit.ManualVoucherServiceType.getIn([
    'all',

    'content',
  ]);

  if (source !== serviceTypesSource) {
    serviceTypesSource = source;

    manualVoucherServiceTypesCache = source ? source.toJS() : [];
  }

  return manualVoucherServiceTypesCache;
};

const getCurrentCurrencyRate = (state) => {
  const source = state.SapServiceLayer.CurrencyRate.getIn([
    'current',

    'content',
  ]);

  if (source !== currencyRateSource) {
    currencyRateSource = source;

    currencyRateCache = source ? source.toJS() : {};
  }

  return currencyRateCache;
};

const mapStateToProps = (state) => ({
  loading: !state.AccountingUnit.ManualVoucher.getIn([
    'current',

    'activity',
  ]).isEmpty(),

  items: selector(state, 'items'),

  totalAmount: selector(state, 'totalAmount'),

  detraction: selector(state, 'detraction'),

  voucherTypeOptions: getVoucherTypeOptions(state),

  cargoCorporateCreditValues: state.CorporateUnit.CargoCorporateCredit.getIn([
    'current',

    'manualVoucherValues',
  ]),

  ticketCorporateCreditValues: state.CorporateUnit.TicketCorporateCredit.getIn([
    'current',

    'manualVoucherValues',
  ]),

  manualVoucherServiceTypes: getManualVoucherServiceTypes(state),

  currencyRate: getCurrentCurrencyRate(state),
});

const mapDispatchToProps = {
  dispatchChange: change,

  dispatchClearCargoCorporateCreditManualVoucherValues:
    clearCargoCorporateCreditManualVoucherValues,

  dispatchClearTicketCorporateCreditManualVoucherValues:
    clearTicketCorporateCreditManualVoucherValues,

  dispatchGetCurrencyRate: getCurrencyRate,

  dispatchClearCurrencyRate: clearCurrencyRate,
};

const formComponent = reduxForm({
  form: 'ManualVoucherForm',

  validate: validateFields,
})(ManualVoucherForm);

export default connect(mapStateToProps, mapDispatchToProps)(formComponent);
